import { useEffect } from 'react';
import type React from 'react';

import { useLocation } from 'react-router';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundContainer } from './NotFound';

export const InvalidRouteContainer: React.FC<EmptyProps> = () => {
	const {
		errorReporter: { report },
	} = useUtilityContext();

	const { pathname } = useLocation();

	useEffect(() => {
		void report({
			error: new Error('Invalid route'),
		});
	}, [report, pathname]);

	return <NotFoundContainer />;
};
